<template>
<div class="develop">

	<!-- 头部 -->
	<zmlmenupage cn-name='发展历程' en-name='Development History'></zmlmenupage>

	<zmlpagebanner banner-img='static/img/aboutBanner.png' banner-text='货运江湖，一键启航！' cn-name='发展历程' en-name='Development History'>
	</zmlpagebanner>

	<div class="develop-content">
		<div class="info develop-content-info">
			<div class="develop-content-textBox flex">
				<div class="develop-content-text1">
					<p>127</p>
					<p>UPDATE</p>
					<p>历经127次升级迭代匠心而成</p>
				</div>
				<div class="develop-content-text2">
					<!-- <p>BEFORE</p>
						<p>曾经</p>
						<p>华南前期</p>
						<p>水运交易平台</p> -->
				</div>
				<div class="jiantou">
					<!-- <img src="../../static/img/jiantou.png" width="72" alt=""> -->
				</div>
				<div class="develop-content-text2">
					<!-- <p>NOW</p>
						<p>现在</p>
						<p>珠江水系</p>
						<p>水运交易平台</p> -->
				</div>
			</div>
			<div class="develop-content-textBox2 flex">
				<div class="develop-content-text1">
					<p>987</p>
					<p>TEST</p>
					<p>历经987次技术测试精心打造</p>
				</div>
				<div class="develop-content-text2">
				</div>
				<div class="jiantou">
				</div>
				<div class="develop-content-text2">
				</div>
			</div>
			<p style="margin-top:-10px">实验室级研发要求，数十位高级软件工程师；历经127次升级迭代，987次技术测试</p>
			<!-- <div class="develop-course flex">
				<div>
					<p class="develop-content-text">企业历程</p>
					<p>BUSINESS PROCESS</p>
				</div>
				</div> -->
		</div>
	</div>

	<div class="develop-history">
		<div class="info develop-history-info">
			<div class="develop-title">
				发展历程
			</div>
			<div class="develop-history-swiper">
				<swiper ref="mySwiper" :options="swiperOptions">
					<swiper-slide>
						<!-- <p class="years">2018</p> -->
						<div class="develop-history-slide flex">
							<div class="develop-history-item">
								<!-- <div class="develop-history-item-img"><img src="../../static/img/about2.png" width="284" alt=""></div> -->
								<div class="txt-center">
									<p>调研无船/无车承运人项目</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2016</p>
									<p></p>
								</div>
							</div>
							<div class="develop-history-item">
								<!-- <div class="develop-history-item-img"><img src="../../static/img/about7.png" width="284" alt=""></div> -->
								<div class="txt-center">
									<p>广东货多多物流科技股份有限公司成立</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2018</p>
									<p>8</p>
								</div>
							</div>
							<div class="develop-history-item">
								<!-- <div class="develop-history-item-img"><img src="../../static/img/about8.png" width="284" alt=""></div> -->
								<div class="txt-center">
									<p>获得无船承运业务经营资格登记证</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2018</p>
									<p>10</p>
								</div>
							</div>
							<div class="develop-history-item">
								<!-- <div class="develop-history-item-img"><img src="../../static/img/about9.png" width="284" alt=""></div> -->
								<div class="txt-center">
									<p>广东货多多物流科技股份有限公司
										江西分公司成立</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2019</p>
									<p>2</p>
								</div>
							</div>
						</div>
					</swiper-slide>
					<swiper-slide>
						<div class="develop-history-slide flex">
							<div class="develop-history-item">
								<!-- <div class="develop-history-item-img"><img src="../../static/img/fazhan2.jpg" width="284" alt=""></div> -->
								<div class="txt-center">
									<p>货运江湖1.0正式上线</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2019</p>
									<p>3</p>
								</div>
							</div>
							<div class="develop-history-item">
								<!-- <div class="develop-history-item-img"><img src="../../static/img/fazhan3.jpg" width="284" alt=""></div> -->
								<div class="txt-center">
									<p>货运江湖平台货主注册数累计达1000+</p>
									<p>船东用户注册数累计达3000+</p>
									<p>单月运费交易额突破1000万</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2019</p>
									<p>9</p>
								</div>
							</div>
							<div class="develop-history-item">
								<!-- <div class="develop-history-item-img"><img src="../../static/img/fazhan4.jpg" width="284" alt=""></div> -->
								<div class="txt-center">
									<p>货运江湖2.0全新改版上线打造多式联运模式</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2020</p>
									<p>6</p>
								</div>
							</div>
							<div class="develop-history-item">
								<!-- <div class="develop-history-item-img"><img src="../../static/img/fazhan5.jpg" width="284" alt=""></div> -->
								<div class="txt-center">
									<p>获得广东省网络货运 </p>
									<p>道路运输经营许可证，</p>
									<p> 打造多式联运模式</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2020</p>
									<p>7</p>
								</div>
							</div>
						</div>
					</swiper-slide>
					<swiper-slide>
						<div class="develop-history-slide flex">
							<!-- <div class="develop-history-item">
								<div class="txt-center">
									<p>广东货多多物流科技股份有限公司安徽分公司成立</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2020</p>
									<p>11</p>
								</div>
							</div> -->
							<div class="develop-history-item">
								<div class="txt-center">
									<p>成为国家高新技术企业</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2020</p>
									<p>12</p>
								</div>
							</div>
							<!-- <div class="develop-history-item">
								<div class="txt-center">
									<p>广东货多多物流科技股份有限公司珠海分公司成立</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2021</p>
									<p>1</p>
								</div>
							</div> -->
							<div class="develop-history-item">
								<div class="txt-center">
									<p>成为广东省首家网络货运代征试点单位</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2021</p>
									<p>3</p>
								</div>
							</div>
							<div class="develop-history-item">
								<div class="txt-center">
									<p>货多多江西分公司成为网络货运代征试点单位</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2021</p>
									<p>4</p>
								</div>
							</div>
							<div class="develop-history-item">
								<div class="txt-center">
									<p>广东货多多物流科技股份有限公司抚州分公司成立</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2022</p>
									<p>5</p>
								</div>
							</div>
							<div class="develop-history-item">
								<div class="txt-center">
									<p>货运江湖货运险业务上线</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2022</p>
									<p>7</p>
								</div>
							</div>
							<div class="develop-history-item">
								<div class="txt-center">
									<p>货运江湖加油业务上线</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2023</p>
									<p>5</p>
								</div>
							</div>
							<!-- <div class="develop-history-item">
								</div> -->
						</div>
					</swiper-slide>
					<!-- <swiper-slide>
						<div class="develop-history-slide flex">
							
						
							
						</div>
					</swiper-slide> -->
				</swiper>
			</div>
			<div class="develop-history-pagination">
				<div class="swiper-pagination" slot="pagination"></div>
			</div>
		</div>
		<span class="fenge"></span>
	</div>

	<!-- <div class="develop-honor">
			<div class="info develop-honor-info">
				<div class="develop-title">
					取得荣誉
				</div>
				<ul class="clearfix">
					<li>广东省交通运输协会理事会员</li>
					<li>广东省惠来商会副秘书长单位</li>
					<li>国务院交通运输部定点单位</li>
				</ul>
			</div>
		</div> -->


	<!-- 移动端 -->
	<div class="phone-develop">
		<div class="phone-develop1">
			<div class="phone-develop1-text1">
				<p>实验室级研发要求，数十位高级软件工程师；</p>
				<p>历经127次升级迭代，987次技术测试</p>
			</div>
			<div class="phone-develop1-text2">127</div>
			<div class="phone-develop1-text3">UPDATE</div>
			<div class="phone-develop1-text4">
				<p>历经127次升级迭代</p>
				<p>匠心而成</p>
			</div>
			<div class="phone-develop1-text2">987</div>
			<div class="phone-develop1-text3">TEST</div>
			<div class="phone-develop1-text4">
				<p>历经987次技术测试</p>
				<p>精心打造</p>
			</div>
			<div class="phone-develop1-text5 flex">
				<div class="develop-content-text2">
					<!-- <p>BEFORE</p>
						<p>曾经</p>
						<p>华南前期</p>
						<p>水运交易平台</p> -->
				</div>
				<div class="jiantou">
					<!-- <img src="../../static/img/jiantou.png" width="72" alt=""> -->
				</div>
				<div class="develop-content-text2">
					<!-- <p>NOW</p>
						<p>现在</p>
						<p>珠江水系</p>
						<p>水运交易平台</p> -->
				</div>
			</div>
			<img src="../../static/img/about11.png" width="100%" alt="">
		</div>
		<div class="phone-develop2">
			<span class="fenge"></span>
			<div class="develop-title">
				发展历程
			</div>
			<div class="develop-history-swiper">
				<swiper ref="mySwiper" :options="swiperOptions">
					<swiper-slide>
						<!-- <p class="years">2018</p> -->
						<div class="develop-history-slide flex">
							<div class="develop-history-item">
								<!-- <div class="develop-history-item-img"><img src="../../static/img/about2.png" width="284" alt=""></div> -->
								<div class="txt-center">
									<p>调研无车/无船承运人项目</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2016</p>
									<p></p>
								</div>
							</div>
							<div class="develop-history-item">
								<!-- <div class="develop-history-item-img"><img src="../../static/img/about8.png" width="284" alt=""></div> -->
								<div class="txt-center">
									<p>广东货多多物流科技股份有限公司成立</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2018</p>
									<p>8</p>
								</div>
							</div>
						</div>
					</swiper-slide>
					<swiper-slide>
						<div class="develop-history-slide flex">
						
								<div class="develop-history-item">
								<!-- <div class="develop-history-item-img"><img src="../../static/img/about9.png" width="284" alt=""></div> -->
								<div class="txt-center">
									<p>获得无船承运业务经营资格登记证</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2018</p>
									<p>10</p>
								</div>
							</div>
											<div class="develop-history-item">
								<!-- <div class="develop-history-item-img"><img src="../../static/img/fazhan2.jpg" width="284" alt=""></div> -->
								<div class="txt-center">
									<p>货运江湖内测试点运营</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2018</p>
									<p>12</p>
								</div>
							</div>
						</div>
					</swiper-slide>
					<swiper-slide>
						<div class="develop-history-slide flex">
			
								<div class="develop-history-item">
								<!-- <div class="develop-history-item-img"><img src="../../static/img/fazhan3.jpg" width="284" alt=""></div> -->
								<div class="txt-center">
									<p>货运江湖1.0测试通过正式上线</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2019</p>
									<p>3</p>
								</div>
							</div>
										<div class="develop-history-item">
								<!-- <div class="develop-history-item-img"><img src="../../static/img/fazhan5.jpg" width="284" alt=""></div> -->
								<div class="txt-center">
									<p>货运江湖平台货主注册数累计达1000+ 船东用户注册数累计达5000+ 单月运费交易额突破1000万
									</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2019</p>
									<p>9</p>
								</div>
							</div>
						</div>
					</swiper-slide>
					<swiper-slide>
						<div class="develop-history-slide flex">
							<div class="develop-history-item">
								<div class="txt-center">
									<p>货运江湖2.0全新改版上线</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2020</p>
									<p>6</p>
								</div>
							</div>
							<div class="develop-history-item">
								<div class="txt-center">
									<p>获得广东省首批网络货运道路运输经营许可证，打造多式联运模式</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2020</p>
									<p>7</p>
								</div>
							</div>
						</div>
					</swiper-slide>
					<swiper-slide>
						<div class="develop-history-slide flex">
							<!-- <div class="develop-history-item">
								<div class="txt-center">
									<p>广东货多多物流科技股份有限公司珠海分公司成立</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2021</p>
									<p>1</p>
								</div>
							</div> -->
							<div class="develop-history-item">
								<div class="txt-center">
									<p>成为广东省首家网络货运代征试点单位</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2021</p>
									<p>3</p>
								</div>
							</div>
							
						</div>
					</swiper-slide>
						<swiper-slide>
						<div class="develop-history-slide flex">
							<!-- <div class="develop-history-item">
								<div class="txt-center">
									<p>广东货多多物流科技股份有限公司天津分公司成立</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2021</p>
									<p>11</p>
								</div>
							</div> -->
							<div class="develop-history-item">
								<div class="txt-center">
									<p>广东货多多物流科技股份有限公司抚州分公司成立</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2022</p>
									<p>5</p>
								</div>
							</div>
							<div class="develop-history-item">
								<div class="txt-center">
									<p>货运江湖货运险业务上线</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2022</p>
									<p>7</p>
								</div>
							</div>
							<div class="develop-history-item">
								<div class="txt-center">
									<p>货运江湖加油业务上线</p>
								</div>
								<span></span>
								<div class="develop-history-node flexCenter">
									<div class="flexCenter"><span></span></div>
								</div>
								<div class="develop-history-item-text">
									<p>2023</p>
									<p>5</p>
								</div>
							</div>
						</div>
					</swiper-slide>
				</swiper>
				<div class="swiper-pagination" slot="pagination"></div>
			</div>
		</div>
		<!-- <div class="phone-develop3">
				<div class="info develop-honor-info">
					<div class="develop-title">
						取得荣誉
					</div>
					<ul class="clearfix">
						<li>广东省交通运输协会理事会员</li>
						<li>广东省惠来商会副秘书长单位</li>
						<li>国务院交通运输部定点单位</li>
					</ul>
				</div>
			</div> -->
	</div>
	<gototop></gototop>
</div>
</template>
<script>
export default {
  name: "develop",
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        // spaceBetween : 120,
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
};
</script>
<style scoped="scoped">
.develop-title {
  padding-top: 100px;
  padding-bottom: 40px;
  font-size: 28px;
  color: #282828;
  font-weight: bold;
}

.develop-content {
  width: 100%;
  height: 734px;
  background: url(../../static/img/about11.png) no-repeat right -8%;
  background-size: 50%;
  background-color: #f4f4f6;
}

.develop-content-info {
  display: flex;
  flex-flow: column;
  justify-content: center;
}

.develop-content-info > p {
  font-size: 20px;
  color: #282828;
  margin-top: 66px;
}

.develop-content-textBox2 {
  display: inline-block;
  width: 300px;
  height: 400px;
  align-items: flex-end;
  margin-top: -315px;
  margin-left: 400px;
}

.develop-content-textBox {
  align-items: flex-end;
}

.develop-content-text1 {
  text-align: center;
  margin-right: 60px;
}

.develop-content-text1 > p:nth-of-type(1) {
  font-size: 140px;
  color: #127bfd;
  font-weight: bold;
  letter-spacing: -10px;
}

.develop-content-text1 > p:nth-of-type(2) {
  font-size: 40px;
  color: #282828;
  margin-top: -20px;
  font-family: arial;
  font-weight: bold;
}

.develop-content-text1 > p:nth-of-type(3) {
  max-width: 180px;
  font-size: 20px;
  color: #282828;
  margin: auto;
  margin-top: 20px;
}

.develop-content-text2 {
  text-align: center;
}

.develop-content-text2 > p:nth-of-type(1) {
  font-size: 50px;
  color: #282828;
  font-weight: bold;
}

.develop-content-text2 > p:nth-of-type(2) {
  font-size: 24px;
}

.develop-content-text2 > p:nth-of-type(3) {
  font-size: 20px;
  margin-top: 40px;
}

.develop-content-text2 > p:nth-of-type(4) {
  font-size: 20px;
}

.years {
  font-size: 50px;
  color: #282828;
  margin-bottom: 40px;
}

.develop-history {
  width: 100%;
  height: 612px;
  background-color: #ffffff;
  overflow: hidden;
  position: relative;
}

.fenge {
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #f4f4f6;
  top: 350px;
  left: 0;
}

.swiper-container {
  overflow: inherit;
}

.develop-history-slide {
  justify-content: space-between;
}

.develop-history-item {
  width: 284px;
  overflow: hidden;
  height: auto;
  /* margin-right: 183px; */
  margin: 0 10px;
}

.develop-history-item > span {
  display: block;
  width: 2px;
  height: 24px;
  background-color: #e1e1e6;
  margin: auto;
  margin-top: 23px;
  margin-bottom: 8px;
  transition: 0.3s;
}

.develop-history-item-img {
  width: 100%;
  height: 167px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.develop-history-item-img img {
  transition: 0.3s;
  width: 100%;
}

.develop-history-item .develop-history-node {
  width: 34px;
  height: 34px;
  background-color: #fff;
  margin: auto;
  transition: 0.3s;
}

.develop-history-item .develop-history-node div {
  width: 24px;
  height: 24px;
  border: 1px solid rgba(173, 173, 176, 1);
  border-radius: 50%;
  transition: 0.3s;
}

.develop-history-item .develop-history-node div span {
  display: block;
  width: 12px;
  height: 12px;
  background: rgba(173, 173, 176, 1);
  border-radius: 50%;
  transition: 0.3s;
}

.develop-history-item .develop-history-item-text {
  text-align: center;
  margin-top: 20px;
  font-size: 16px;
  color: #666;
  transition: 0.3s;
}

.develop-history-item .develop-history-item-text p:nth-of-type(1) {
  font-size: 28px;
  color: #282828;
  margin-bottom: 10px;
  transition: 0.3s;
}

.develop-history-pagination {
  position: relative;
  padding: 60px 0;
}

.swiper-pagination {
  position: relative;
}

>>> .swiper-pagination-bullet {
  width: 18px;
  height: 18px;
  background-color: rgba(255, 255, 255, 0);
  border: 1px solid #fff;
  position: relative;
  margin: 0 5px;
  border-radius: 50%;
  outline: none;
  opacity: 1;
}

>>> .swiper-pagination-bullet::before {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #adadb0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

>>> .swiper-pagination-bullet-active {
  border: 1px solid #127bfd;
}

>>> .swiper-pagination-bullet-active::before {
  background-color: #127bfd;
}

/* .develop-history-item:hover .develop-history-node{
	transform: scale(1.3);
}
.develop-history-item:hover .develop-history-node div{
	border: 1px solid #127BFD;
}
.develop-history-item:hover .develop-history-node div span{
	background-color: #127BFD;
}
.develop-history-item:hover img{
	transform: scale(1.2);
	overflow: hidden;
}
.develop-history-item:hover>span{
	background-color: #127BFD;
}
.develop-history-item:hover .develop-history-item-text{
	color: #127BFD;
}
.develop-history-item:hover .develop-history-item-text p:nth-of-type(1){
	color: #127BFD;
} */

.develop-honor {
  width: 100%;
  height: auto;
  background-color: #f4f4f6;
}

.develop-honor-info {
  padding-bottom: 180px;
}

.develop-honor-info ul li {
  width: 30%;
  list-style: disc;
  color: #666;
  float: left;
  margin-left: 20px;
  margin-bottom: 20px;
}

.jiantou {
  margin-bottom: 148px;
  margin: 0 40px 148px 40px;
}

.phone-develop {
  display: none;
}

.txt-center {
  text-align: center;
  display: inline-block;
  height: 96px;
  width: 100%;
}

.develop-course {
  margin-top: -400px;
}

.develop-content-text {
  display: inline-block;
  font-size: 80px;
  color: #127bfd;
  font-weight: bold;
  letter-spacing: -6px;
}

@media only screen and (max-width: 1600px) {
}

@media only screen and (max-width: 750px) {
  .phone-develop {
    display: block;
    overflow: hidden;
  }
  .develop-content,
  .develop-history,
  .develop-honor {
    display: none;
  }
  .phone-develop1 {
    background-color: #f4f4f6;
    text-align: center;
    overflow: hidden;
  }
  .phone-develop1-text1 {
    font-size: 13px;
    line-height: 20px;
    margin-top: 40px;
  }
  .phone-develop1-text2 {
    font-size: 102px;
    color: #127bfd;
    font-weight: bold;
    letter-spacing: -10px;
  }
  .phone-develop1-text3 {
    font-size: 29px;
    font-weight: bold;
  }
  .phone-develop1-text4 {
    font-size: 15px;
    line-height: 20px;
    margin-top: 8px;
  }
  .phone-develop1-text5 {
    justify-content: center;
    margin-top: 30px;
  }
  .phone-develop1-text5 .develop-content-text2 {
    font-size: 14px;
  }
  .develop-content-text2 > p:nth-of-type(1) {
    font-size: 25px;
  }
  .develop-content-text2 > p:nth-of-type(2) {
    font-size: 14px;
  }
  .develop-content-text2 > p:nth-of-type(3) {
    font-size: 14px;
    margin-top: 20px;
  }
  .develop-content-text2 > p:nth-of-type(4) {
    font-size: 14px;
    margin-top: 0;
  }
  .jiantou {
    margin: 0 24px;
    margin-top: 10px;
  }
  .jiantou img {
    width: 36px !important;
  }
  .phone-develop2 {
    padding: 0px 23px;
    padding-bottom: 100px;
    position: relative;
  }
  .phone-develop2 .fenge {
    top: 248px;
  }
  .develop-history-item {
    margin-right: 10px;
  }
  .develop-title {
    padding-top: 50px;
    padding-bottom: 20px;
    font-size: 14px;
  }
  .years {
    font-size: 25px;
    margin-bottom: 20px;
  }
  .develop-history-item-img {
    height: auto;
  }
  .develop-history-item-img img {
    width: 100%;
  }
  .develop-history-item > span,
  .develop-history-item .develop-history-node,
  .develop-history-item .develop-history-item-text {
    font-size: 12px;
    margin-top: 10px;
  }
  .develop-history-item .develop-history-item-text p:nth-of-type(1) {
    font-size: 12px;
  }
  .develop-history-item > span {
    margin: 10px auto;
    height: 12px;
  }
  .develop-honor-info ul li {
    width: 100%;
    font-size: 12px;
  }
  .phone-develop3 {
    background-color: #f4f4f6;
  }
  .fenge {
    display: none;
  }
  .swiper-pagination {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/develop.vue